module.exports = __webpack_public_path__ + "media/images/bg/shapes/gallery/activities-3955068c90c9e65a6912aed4eb7e8243.svg";